import { UserRole } from '@/types';

export const HEALTH_INSURANCE_ID = '7';

export const ROLE_TO_ROUTES: { [key: string]: string[] } = {
   [UserRole.ADMIN]: ['/moh-admin'],
   [UserRole.INSURANCE_ADMIN]: ['/insurance'],
   common: ['/patient/profile', '/notifications', '/bills/viewBill'],
};
